import { Box, ListItem, ListItemText, Typography, Collapse, List } from '@mui/material'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import React, { FC, useState } from 'react'
import ParticipantListItem from './ParticipantListItem/ParticipantListItem'
import { HomeViewParticipantFragment } from './searchParticipants.generated'

export const Participants: FC<{
  participants: HomeViewParticipantFragment[]
  label: string
  selectedUid?: string
  showDayIndicator?: boolean
  isLastGroup?: boolean
}> = ({ participants, label, selectedUid, showDayIndicator = false, isLastGroup = false }) => {
  const [isExpand, setIsExpand] = useState<boolean>(true)
  return (
    <Box pb={isLastGroup ? 0 : 2}>
      <ListItem button onClick={() => setIsExpand(!isExpand)}>
        <ListItemText
          primary={
            <Typography variant="h3" sx={{ textTransform: 'capitalize' }}>
              {label}
            </Typography>
          }
        />
        {isExpand ? <ExpandLess titleAccess="collapse" /> : <ExpandMore titleAccess="expand" />}
      </ListItem>
      <Collapse in={isExpand} timeout="auto" unmountOnExit>
        <List disablePadding>
          {participants.map(
            ({ uid, firstname, lastname, indicators, tags, enrollment, timezone, language, details }) => (
              <ParticipantListItem
                key={uid}
                active={selectedUid === uid}
                uid={uid}
                firstname={firstname}
                lastname={lastname}
                programID={enrollment?.programID}
                language={language}
                source={typeof details?.source === 'string' ? details.source : null}
                indicators={indicators}
                tags={tags}
                programStartDate={enrollment?.programStartDate}
                showDayIndicator={showDayIndicator}
                timezone={timezone}
                enrolledFromPreviousAdvancedProgram={enrollment?.enrolledFromPreviousAdvancedProgram}
                enrollmentCreatedAt={enrollment?.createdAt}
              />
            )
          )}
        </List>
      </Collapse>
    </Box>
  )
}
